import './SectionDescription.css';
import React, {useState} from 'react';

function SectionDescription(props) {

  const [opened, setOpened] = useState(false);

  return (
      <>
        <div className="cat-section-desc">
          <div className="image-block">
            <picture>
              {props.pictureMobileSrc && (
                  <source media="(max-width:676px)"
                          srcSet={props.pictureMobileSrc}/>
              )}
              <img src={props.pictureSrc}/>
            </picture>
          </div>
          {
              props.sectionText && (
                  <div className={`description-block ${opened || !props.sectionButtonName ? 'opened' : ''}`}>
                    <div className="text"
                         dangerouslySetInnerHTML={{__html: props.sectionText}}/>
                    {
                      props.sectionButtonName && (
                        <div className="button">
                          <span className="btn"
                                onClick={event => {
                                  event.preventDefault();
                                  setOpened(!opened);
                                }}>
                            {props.sectionButtonName}
                          </span>
                        </div>
                      )
                    }
                  </div>
            )
          }
        </div>
      </>
  );
}

export default SectionDescription;